import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TMoodleUser, TQuiz, TGame } from "./MoodleTypes";

export interface IMoodleState {
  game: TGame | null;
  quizzes: TQuiz[];
  courseBlocks: any[];
}

const initialState: IMoodleState = {
  game: null,
  quizzes: [],
  courseBlocks: [],
};
// action: PayloadAction<HomeLayout>
export const moodleSlice = createSlice({
  name: "moodle",
  initialState,
  reducers: {
    setQuizzes: (state, action: PayloadAction<TQuiz[]>) => {
      console.log("SET QUIZES", action.payload);
      if (action.payload) state.quizzes = action.payload;
    },
    setCourseBlocks: (state, action: PayloadAction<any[]>) => {
      console.log("SET QUIZES", action.payload);
      if (action.payload) state.courseBlocks = action.payload;
    },
    setGame: (state, action: PayloadAction<TGame | null>) => {
      console.log("SET GAME", action.payload);
      if (action.payload) state.game = action.payload;
    },
  },
});

export const { setQuizzes, setCourseBlocks, setGame } =
  moodleSlice.actions;

export default moodleSlice.reducer;
